import React from "react";

import "react-datetime/css/react-datetime.css";

export const ClientAccountInfo = ({
  name,
  clientAccountCode,
  type,
  industry,
  region,
  accountEmail,
  phone,
  mailingStreet,
  mailingCity,
  mailingState,
  mailingPostalCode,
  mailingCountry,
  backtoForm,
  _,
}) => {
  return (
    <>
      <div className=" mb-4  d-flex report-sent-message">
        <i className="icon-omni-tick-circle mr-2"></i>
        <h6>{_.ClientHub.ClientAccountDetails.ThankYouMessage}</h6>
      </div>
      <div className="container mt-2">
        <div className="d-flex flex-wrap mr-3 client-account-info">
          <div className="d-flex flex-wrap row report-details-1">
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.AccountName}</h6>
              <p title={name}>{name}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.AccountCode}</h6>
              <p>{clientAccountCode}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.Type}</h6>
              <p title={type}>{type}</p>
            </div>
          </div>
          <div className="d-flex row report-details-2">
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.Industry}</h6>
              <p title={industry}>{industry}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.Region}</h6>
              <p title={region}>{region}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.AccountEmail}</h6>
              <p title={accountEmail}>{accountEmail}</p>
            </div>
          </div>
          <div className="d-flex row report-details-3">
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.TelephoneNumber}</h6>
              <p title={phone}>{phone}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.MailingStreet}</h6>
              <p title={mailingStreet}>{mailingStreet}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.MailingCity}</h6>
              <p title={mailingCity}>{mailingCity}</p>
            </div>
          </div>
          <div className="d-flex row report-details-3">
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.MailingStateProvince}</h6>
              <p title={mailingState}>{mailingState}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.MailingPostCode}</h6>
              <p title={mailingPostalCode}>{mailingPostalCode}</p>
            </div>
            <div className="col-4">
              <h6>{_.ClientHub.ClientAccountDetails.MailingCountry}</h6>
              <p title={mailingCountry}>{mailingCountry}</p>
            </div>
          </div>
        </div>
        <div className="d-flex mt-3 green-button justify-content-start ">
          <button
            className="d-flex justify-content-center styled-button mt-4 "
            type="button"
            onClick={backtoForm}
          >
            {_.ClientHub.ClientAccountDetails.ReturnToClientAccount}
          </button>
        </div>
      </div>
    </>
  );
};
